import React, { useState, useEffect } from 'react';

const API = '/api';

export default function OnboardingDashboard({ token }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API}/portal/onboarding/${token}`)
      .then(r=>r.json())
      .then(d=>{ if(d.error) setError(d.error); else setData(d); })
      .catch(()=>setError('Failed to load. Please try again.'))
      .finally(()=>setLoading(false));
  }, [token]);

  if (loading) return <div className="spinner"/>;

  if (error) return (
    <div className="page">
      <div className="card" style={{textAlign:'center'}}>
        <div style={{fontSize:48,marginBottom:16}}>⚠️</div>
        <h2 style={{fontFamily:'Cormorant Garamond,serif',fontSize:'1.8rem',
          color:'#8F2E24',marginBottom:8}}>{error}</h2>
        <p className="text-muted">Please contact HR if you believe this is an error.</p>
      </div>
    </div>
  );

  const steps = [
    { key:'offer', label:'Offer Accepted', done: data?.offer_accepted },
    { key:'guarantor', label:'Guarantor Submitted', done: data?.guarantor_submitted },
    { key:'guarantor_approved', label:'Guarantor Approved', done: data?.guarantor_approved },
    { key:'agreement', label:'Employment Agreement Signed', done: data?.agreement_signed },
    { key:'documents', label:'Documents Complete', done: data?.documents_complete },
    { key:'active', label:'Active Steward', done: data?.is_active },
  ];

  const completedSteps = steps.filter(s=>s.done).length;
  const progress = Math.round((completedSteps/steps.length)*100);

  return (
    <div className="page">
      <div className="card">
        <div style={{marginBottom:20}}>
          <div style={{fontSize:11,color:'#A8893D',fontWeight:700,
            textTransform:'uppercase',letterSpacing:'.1em',marginBottom:4}}>
            Onboarding Progress
          </div>
          <h1 style={{fontFamily:'Cormorant Garamond,serif',fontSize:'1.6rem',
            color:'#2C1F16',marginBottom:4}}>
            Welcome, {data?.prospect_name}
          </h1>
          <p className="text-muted">{data?.position} · {data?.department}</p>
        </div>

        {/* Progress bar */}
        <div style={{marginBottom:24}}>
          <div style={{display:'flex',justifyContent:'space-between',
            fontSize:12,color:'#8A8A8A',marginBottom:6}}>
            <span>Overall Progress</span>
            <span>{progress}%</span>
          </div>
          <div style={{height:8,background:'#E8E0D4',borderRadius:4}}>
            <div style={{width:progress+'%',height:8,background:'#556B2F',
              borderRadius:4,transition:'width .3s'}}/>
          </div>
        </div>

        {/* Steps */}
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {steps.map((step,i)=>(
            <div key={step.key} style={{display:'flex',alignItems:'center',gap:12,
              padding:14,borderRadius:10,
              background:step.done?'#E8F5EB':'#F9F8F5',
              border:`1px solid ${step.done?'#B8DEC0':'#E8E0D4'}`}}>
              <div style={{width:32,height:32,borderRadius:'50%',flexShrink:0,
                background:step.done?'#2E6B3A':'#E8E0D4',
                display:'flex',alignItems:'center',justifyContent:'center',
                fontSize:14,color:step.done?'#fff':'#8A8A8A',fontWeight:700}}>
                {step.done ? '✓' : i+1}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600,
                  color:step.done?'#2E6B3A':'#2C1F16'}}>{step.label}</div>
              </div>
              {step.done && (
                <span style={{fontSize:10,color:'#2E6B3A',fontWeight:600}}>COMPLETE</span>
              )}
              {!step.done && i===completedSteps && (
                <span style={{fontSize:10,color:'#8B5E0A',fontWeight:600}}>PENDING</span>
              )}
            </div>
          ))}
        </div>

        {/* Next action */}
        {data?.next_action && (
          <div style={{marginTop:20,background:'#FFF3DC',borderRadius:10,
            padding:14,fontSize:13,color:'#8B5E0A'}}>
            <strong>Next step:</strong> {data.next_action}
          </div>
        )}

        <div style={{marginTop:20,fontSize:12,color:'#8A8A8A',textAlign:'center'}}>
          Questions? Contact HR at <strong>hr@bloanshandbags.com</strong>
        </div>
      </div>
    </div>
  );
}
